module.exports = __webpack_public_path__ + "img/Indentify.0422bd8c.png";